export const trainersData = [
  {
    Image: "user-32.jpg",
    Name: "Anthony Lewis",
    Phone: "(123) 4567 890",
    Email: "anthony@example.com",
    Description: "Anthony is a trainer known for his expertise in leadership development.",
    Status: "Active",
    key: "1",
  },
  {
    Image: "user-09.jpg",
    Name: "Brian Villalobos",
    Phone: "(179) 7382 829",
    Email: "brian@example.com",
    Description: "Brian is a trainer who excels in teaching advanced technical skills.",
    Status: "Active",
    key: "2",
  },
  {
    Image: "user-01.jpg",
    Name: "Harvey Smith",
    Phone: "(184) 2719 738",
    Email: "harvey@example.com",
    Description: "Harvey is a trainer known for his expertise in conflict resolution.",
    Status: "Active",
    key: "3",
  },
  {
    Image: "user-33.jpg",
    Name: "Stephan Peralt",
    Phone: "(193) 7839 748",
    Email: "peral@example.com",
    Description: "Stephan is a trainer who enhances creative problem-solving skills.",
    Status: "Active",
    key: "4",
  },
  {
    Image: "user-34.jpg",
    Name: "Doglas Martini",
    Phone: "(183) 9302 890",
    Email: "martniwr@example.com",
    Description: "Doglas is a trainer who enhances project management skills.", 
    Status: "Active",
    key: "5",
  },
];
